const menu = [
	// {
	// 	title: "概况",
	// 	path: "/index",
	// 	component: () => import('../views/index.vue')
	// }
];

module.exports = {
	menu
}
